import { Dimensions } from 'types'
import { TextStyle } from '../../../types'

export function measureText(text: string, style: TextStyle): Dimensions {
    const { fontFamily, fontSize, fontWeight } = style
    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')
    const lines = text.split('\n')
    const longestLine = lines.reduce((a, b) => (a.length > b.length ? a : b))
    let width = 0
    let height = 0

    if (context) {
        context.font = `${fontWeight} ${fontSize}px ${fontFamily}`

        const measurements = context.measureText(longestLine)

        height = (measurements.fontBoundingBoxAscent + measurements.fontBoundingBoxDescent) * lines.length
        width = measurements.width
    }

    return { height, width }
}
